import Vue from 'vue';
Vue.use(Notifications);
import Notifications from 'vue-notification';

const Notify = {
    install(Vue) {
        Vue.prototype.$success = function (text = 'Everything went as expected', title = 'Success') {
            this.$notify({
                title,
                text,
                type: 'success'
            });
        },
        Vue.prototype.$warning = function (text = 'Something wasn\'t quite right', title = 'Warning') {
            this.$notify({
                title,
                text,
                type: 'warn'
            });
        },
        Vue.prototype.$error = function (text = 'Something went wrong', title = 'Error') {
            this.$notify({
                title,
                text,
                type: 'error'
            });
        }
    }
}

export default Notify;